package ui.app.assign.detail.definition

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.graphics.vector.*
import androidx.compose.ui.unit.*
import compose.assets.*
import compose.assets.svg.*
import org.jetbrains.compose.resources.*
import ssoft.frontend.generated.resources.*
import tools.*
import ui.app.assign.detail.*
import ui.widget.*

@Composable
fun AppDetailScope.AppDefOfBalloon(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfBalloon
) {
    if (display.isMobile) {
        Column {
            DefaultFields(
                nnvl = wrapper,
                modifier = Modifier.fillMaxWidth(),
                mainContent = {
                    Space(16.dp)
                    ContentFields(wrapper, nnvl, Modifier.fillMaxWidth())
                })
        }
    } else {
        Row {
            Column(Modifier.weight(1F)) {
                DefaultFields(
                    nnvl = wrapper,
                    modifier = Modifier.fillMaxWidth()
                )
            }
            Space(16.dp)
            Column(Modifier.weight(1F)) {
                ContentFields(
                    wrapper = wrapper,
                    nnvl = nnvl,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    }
    Space(64.dp)
}

@Composable
private fun AppDetailScope.ContentFields(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfBalloon,
    modifier: Modifier
) {
    LevelField(
        icon = Svg.Fan,
        field = nnvl.levelDuration,
        canEdit = wrapper.canEdit,
        label = Res.string.layer_bottom_detail__balloon_level_fly_label,
        levels = listOf(
            Res.string.layer_bottom_detail__balloon_level_slow,
            Res.string.layer_bottom_detail__balloon_level_medium,
            Res.string.layer_bottom_detail__balloon_level_fast,
        ),
        modifier = modifier
    )
    Space(16.dp)
    LevelField(
        icon = Svg.Arrow_decision_outline,
        field = nnvl.levelSpawn,
        label = Res.string.layer_bottom_detail__balloon_level_spawn_label,
        levels = listOf(
            Res.string.layer_bottom_detail__balloon_level_slow,
            Res.string.layer_bottom_detail__balloon_level_medium,
            Res.string.layer_bottom_detail__balloon_level_fast,
        ),
        modifier = modifier,
        canEdit = wrapper.canEdit
    )
    Space(16.dp)
    SizeField(
        field = nnvl.sizePct,
        label = Res.string.layer_bottom_detail__balloon_size_label,
        canEdit = wrapper.canEdit,
        modifier = modifier
    )
    Space(16.dp)
    FieldTextInt(
        icon = Svg.Dots_circle,
        field = nnvl.count,
        label = Res.string.layer_bottom_detail__balloon_count_label,
        canEdit = wrapper.canEdit
    )
}


@Composable
private fun AppDetailScope.LevelField(
    icon: ImageVector,
    field: EFieldRegularInt,
    label: StringResource,
    levels: List<StringResource>,
    modifier: Modifier,
    canEdit: Boolean
) {
    var isExpanded by remember {
        mutableStateOf(false)
    }
    Card(modifier = modifier) {
        Column(
            Modifier.padding(16.dp)
                .fillMaxWidth()
        ) {
            Text(label.rememberString())
            Space(8.dp)
            Card(
                enabled = canEdit,
                onClick = { isExpanded = !isExpanded },
                colors = CardDefaults.cardColors(MaterialTheme.colorScheme.inverseSurface)
            ) {
                Row(
                    Modifier.padding(16.dp)
                        .fillMaxWidth()
                ) {
                    Icon(icon, null)
                    Space(8.dp)
                    Text(text = levels[field.state].rememberString())
                }

                DropdownMenu(
                    expanded = isExpanded,
                    onDismissRequest = { isExpanded = false },
                ) {
                    levels.forEachIndexed { index, entry ->
                        DropdownMenuItem(
                            text = { Text(entry.rememberString()) },
                            onClick = {
                                field.set(index)
                                isExpanded = false
                            })

                    }
                }
            }
        }
    }
}


@Composable
private fun AppDetailScope.SizeField(
    field: EFieldRegularFloat,
    label: StringResource,
    canEdit: Boolean,
    modifier: Modifier
) {
    Card(
        colors = CardDefaults.cardColors(MaterialTheme.colorScheme.surfaceVariant),
        modifier = modifier
    ) {
        Column(Modifier.padding(16.dp)) {
            Text(label.rememberString())
            Space(8.dp)
            Card(colors = CardDefaults.cardColors(MaterialTheme.colorScheme.inverseSurface)) {
                PercentageEntry(field, canEdit, steps = 20)
            }
        }
    }
}


